import { render } from "./GraficaClientesMx.vue?vue&type=template&id=5ae7c48a"
import script from "./GraficaClientesMx.vue?vue&type=script&lang=js"
export * from "./GraficaClientesMx.vue?vue&type=script&lang=js"

import "./GraficaClientesMx.vue?vue&type=style&index=0&id=5ae7c48a&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__